var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('select-lang',{model:{value:(_vm.langView),callback:function ($$v) {_vm.langView=$$v},expression:"langView"}}),(_vm.loading)?_c('popup-loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }